import qs from 'qs';

import * as urlUtils from 'utils/url';
import apiUrlConfig from 'configs/apiUrlConfig';
import AuthenticatedRequestService from 'services/requests/Authenticated';

const URLS = {
  INDEX: `${apiUrlConfig.apiEndPoint()}/answers/:id/comments`,
};

function insertIdToUrl(url, id) {
  return url.replace(':id', id);
}

class AnswerComments {
  /**
   * Gets all answer's comments.
   * If the parametes from and to are provided then the comments are filtered according to the timestamp.
   *
   * @param {int} answerId
   * @param {int} from Unix timestamp
   * @param {int} to Unix timestamp
   */
  static getAll(answerId, from, to) {
    const INDEX_URL = insertIdToUrl(URLS.INDEX, answerId);

    return AuthenticatedRequestService.get(
      urlUtils.addQueryParameters(INDEX_URL, { from, to })
    );
  }
}

export default AnswerComments;



// WEBPACK FOOTER //
// ./src/apis/AnswerComments.js